<template>
  <CCardBody class="dataTable__body tableBalance__body p-0" v-if="viewMode.hiddenTable">
    <h4 class="font-weight-normal mb-2">{{ $t(`backoffice.manage.balance.tables.table-balance`) }}</h4>
    <hr v-if="viewMode.haslineNameTable" />
    <!-- {{ currentBalances }} -->
    <CDataTable
      :key="`currentBalancesEmail`"
      v-if="currentBalances.length"
      :fields="itemsFields"
      :items="currentBalances"
      :table-filter="{ external: true, lazy: true }"
      items-per-page-select
      :responsive="false"
      :loading="false"
      hover
    >
      <template #balance="{item}">
        <td class="position-center">
          <span>
            {{ numberWithCommas(item.balance) }}
          </span>
          <TableAlert :payload="item" />
        </td>
      </template>

      <template #value="{item, index}">
        <td class="position-relative ">
          <AddReduceBalance
            :item="item"
            :index="index"
            @toggle-inputValueAll="closeAllModalInputValue"
            @toggle-inputValue="toggleInputValue"
            @incrementOrDecrementBalance="incrementOrDecrementBalance"
            @close-confirmation-inputValuel="closeAllModalInputValue"
          />
        </td>
      </template>

      <template #delete="{item, index}">
        <td class="position-relative text-center">
          <CButton
            :data-cy="'deleteLinecurrentBalancese' + index"
            color="white"
            aria-label="delete"
            title="delete"
            class="tableBalance__btn"
            @click.stop="toggleDelete(item)"
          >
            <CIcon name="trash" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
          </CButton>

          <transition name="fade" v-if="item._modalDelete">
            <div class="dataTable__popUp popUp dataTable__popUp--right popUp" @click.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete
                  :title="''"
                  :description="$t('backOffice.manage.balace.tables.table-one-shot.text-delete')"
                  @confirm="removeBalance(item)"
                  @cancel="toggleDelete(item)"
                />
              </div>
            </div>
          </transition>
        </td>
      </template>
    </CDataTable>

    <AddReduceBalanceEmail
      v-if="show"
      :actionAdd="true"
      :removeCountries="hasContriesInList"
      :item="{ _channel: 'email', _modalChangeValue: 'add', _modalTypeValueActive: 'add', balance: 0 }"
      :index="currentBalances.length + 1"
      @toggle-inputValueAll="closeAllModalInputValue"
      @toggle-inputValue="toggleInputValue"
      @add-balance="incrementOrDecrementBalance"
      @update-LineBalace="incrementOrDecrementBalance"
      @close-confirmation-inputValuel="closeAllModalInputValue"
    />
  </CCardBody>
</template>

<script>
import ConfirmationDelete from '@/components/ConfirmationDelete'
import { actionsRecurring } from '../../mixins/ActionsTransactionsTable'

const fields = [
  { key: 'country', label: 'Country', _classes: 'hidden' },
  { key: 'balance', label: 'Current Balance', _classes: 'hidden' },
  { key: 'value', label: 'ADD/REDUCE', _classes: 'hidden' },
  { key: 'delete', label: '', _classes: 'hidden text-center', _style: 'width:80px' },
]

export default {
  name: 'TableBalanceCurrentEmail',
  components: {
    ConfirmationDelete,
    AddReduceBalanceEmail: () => import('./AddReduceBalanceEmail.vue'),
    AddReduceBalance: () => import('./AddReduceBalance.vue'),
    TableAlert: () => import('./TableAlert.vue'),
  },

  mixins: [actionsRecurring],

  props: {
    currentBalances: {
      type: Array,
      default: () => {},
    },

    channel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itemsTable: [],
      itemsFields: [],
    }
  },

  mounted() {
    // para tabela de currentBalances de email, n é para mostrar a coluna de país
    this.itemsFields = this.channel == 'sms' ? fields : fields.filter(item => item.key !== 'country')
  },

  computed: {
    show() {
      return !(this.channel == 'email' && this.currentBalances.length)
    },

    hasContriesInList() {
      return this.currentBalances.map(item => item.country)
    },

    viewMode() {
      // se state on e não há indices em currentBalances
      if (this.currentBalances.length == 0) {
        return { hiddenTable: true, haslineNameTable: true }
      }

      return { hiddenTable: true }
    },
  },

  methods: {
    addLine(newData) {
      let data = {
        balance: newData.currentBalanceTemp,
        reason: newData.reason,
        _channel: this.channel,
        _typeTable: 'currentBalances',
        _tempId: Math.floor(Math.random() * 1000000),
        _currentBalanceTemp: 1,
        _modalTypeValueActive: '',
        _modalChangeValue: false,
        _modalDelete: false,
        _message: {
          dismissCountDown: false,
          text: '',
          status: '',
        },
      }

      this.$store.commit('backOffice/ADD_LINE', { data, table: 'currentBalances' })
    },

    updateLineBalace(playload) {
      let data = {
        channel: this.channel,
        currentBalance: playload.currentBalanceTemp,
        id: playload.id,
        reason: playload.reason,
      }

      this.$store.commit('backOffice/UPDATE_LINE', data)
    },
  },
}
</script>
